import { History } from 'history';
import { FC, PropsWithChildren, useLayoutEffect, useState } from 'react';
import { Router as ReactRouter } from 'react-router-dom';

type RouterPropsT = PropsWithChildren & {
  history: History;
};

const Router: FC<RouterPropsT> = ({ history, ...props }) => {
  const [stateHistory, setStateHistory] = useState({
    action: history.action,
    location: history.location,
  });

  useLayoutEffect(() => history.listen(setStateHistory), [history]);

  return (
    <ReactRouter
      {...props}
      location={stateHistory.location}
      navigationType={stateHistory.action}
      navigator={history}
    />
  );
};

export default Router;
